import { formatDate } from '@/utils';
import BASE_API from '@/api/dataBase.js';

export default {
  data() {
    return {};
  },
  mounted() {
    // this.getDepartmentList(this.userInfo.companyCode)
  },
  methods: {
    // 获取当前登录人所在的部门
    async getDepartmentList() {
      const params = {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      };
      const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
      let departList = [];
      if (res.data.code === 0) {
        (res.data.data.personDepartmentInfo || []).map((v) => {
          departList.push(v.personDepartmentCode);
        });
      } else {
        departList = [];
      }
      console.log(departList, 'departList');
      return departList || [];
    },
    async getDataByOrderType(requestStatus, orderName, leaseDateUntilStart, leaseDateUntilEnd) {
      this.tableData = [];
      const { path, statusListMap } = this.handleStatus(this.orderName);
      if (!this.orderName) {
        console.log('返回');
        this.$emit('cancel');
        return;
      }
      console.log('请求路径', path, orderName, statusListMap);
      // let orderName = order ? order : this.orderName;
      // if (['租赁合同', '报修管理'].includes(this.orderName)) {
      //   requestStatus = [requestStatus];
      // }
      let postData = {
        plateName: this.indexType,
        requestStatus: requestStatus,
        // companyCode: this.userInfo.companyCode,
        // departmentCode: this.userInfo.departmentCode,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        orderName: this.orderName,
        adminFlag: '2',
        // businessGroup: this.userInfo.businessGroup,
        departmentCodeList: await this.getDepartmentList(),
        // leaseDateUntilStart,
        // leaseDateUntilEnd,

        // ContractEndStart: leaseDateUntilStart,
        // ContractEndEnd: leaseDateUntilEnd,
      };
      // 物业租赁到期合同日期
      if (['租赁合同', '物业合同'].includes(this.orderName)) {
        postData = {
          ...postData,
          leaseDateUntilStart,
          leaseDateUntilEnd,
          contractCategory: this.orderName == '租赁合同' ? '01' : '02',
        };
      }
      // 多式联运到期日期限制
      if (['供方合同', '客方合同'].includes(this.orderName)) {
        postData = {
          ...postData,
          contractEndStart: leaseDateUntilStart,
          contractEndEnd: leaseDateUntilEnd,
        };
      }
      postData = this.handlePostData(postData);
      this.loading = true;
      // console.log('数据', orderName,path,postData);
      this.$emit('openLoading');
      let { data } = await this.$axios.post(path, postData);
      this.$emit('cancel');
      this.loading = false;
      console.log('data', data);
      if (data.code == 0) {
        let tableData = data.data.records || data.data.data.records || data.data.data;
        if (this.orderName == '销售发票申请') {
          this.tableData = tableData?.map((item) => {
            return {
              ...item,
              gmtCreate: item.gmtCreate ? formatDate(item.gmtCreate, true) : '',
              statusMap: ['报修管理', '商品主数据'].includes(this.orderName)
                ? item.orderStatus
                : statusListMap.find((item1) => item1.value == item.orderStatus)?.label,
              orderTypeName: this.dictListMap.invoice_type.find(
                (item1) => item1.value == item.orderTypeName
              )?.label,
            };
          });
        } else if (this.orderName == '立项' && this.indexType == 'cd') {
          this.tableData = tableData?.map((item) => {
            return {
              ...item,
              gmtCreate: item.applyDate ? formatDate(item.applyDate, true) : '',
              statusMap: item.orderStatus,
            };
          });
        } else if (['供方结算条款', '客方结算条款'].includes(this.orderName)) {
          this.tableData = tableData?.map((item) => {
            return {
              ...item,
              gmtCreate: item.applyDate ? formatDate(item.applyDate, true) : '',
              statusMap: item.orderStatus,
              orderTypeName: item.orderTypeName
                ? item.orderTypeName.replace('补充协议', '结算条款')
                : item.orderTypeName,
            };
          });
        } else {
          this.tableData = tableData?.map((item) => {
            return {
              ...item,
              gmtCreate: item.gmtCreate ? formatDate(item.gmtCreate, true) : '',
              statusMap: ['报修管理', '商品主数据', '仓储合同'].includes(this.orderName)
                ? item.orderStatus
                : statusListMap.find((item1) => item1.value == item.orderStatus)?.label,
            };
          });
        }

        this.tableTotal = data.data?.total || data.data.data?.total;
        // this.keyTime = new Date().getTime()
        console.log('tableData', this.tableData);
      } else {
        // this.$message.error(data.msg);
      }
    },
    // 接口请求参数处理
    handlePostData(postData) {
      // 区分客方合同和供方合同
      if (this.orderName == '客方合同') {
        postData.isCS = 'C';
        postData.contractType = '0';
      }
      if (this.orderName == '供方合同') {
        postData.isCS = 'S';
        postData.contractType = '0';
      }
      if (this.orderName == '客方结算条款') {
        postData.isCS = 'C';
        postData.contractType = '1';
      }
      if (this.orderName == '供方结算条款') {
        postData.isCS = 'S';
        postData.contractType = '1';
      }
      // 区分采购合同和销售合同
      if (this.orderName == '采购合同') {
        postData.contractCategory = 'purchase';
        if (this.userInfo.businessGroup == '城矿') {
          postData.dataGroup = 'zjmi';
        }
        if (this.userInfo.businessGroup == '物贸') {
          postData.dataGroup = 'wm';
        }
      }
      if (this.orderName == '销售合同') {
        postData.contractCategory = 'sales';
        if (this.userInfo.businessGroup == '城矿') {
          postData.dataGroup = 'zjmi';
        }
        if (this.userInfo.businessGroup == '物贸') {
          postData.dataGroup = 'wm';
        }
      }
      // 区分销售合同和销售协议
      if (this.orderName == '销售合同') {
        postData.contractDetailCategory = '销售合同';
      }
      if (this.orderName == '销售协议') {
        postData.contractDetailCategory = '销售协议';
      }
      if (this.orderName == '立项' && this.indexType == 'cd') {
        postData.companyName = this.userInfo.companyName;
      }
      // 主数据 做公司权限隔离
      if (this.orderName == '商品主数据') {
        postData.companyCode = this.userInfo.companyCode;
      }
      return postData;
    },
  },
};
